const resources = {
  "en": {
    "forgotPassword": {
      "title": "🔑 Reset Password",
      "submit": "Send reset link",
      "sent": "If that email is registered, a reset link has been sent."
    }
  },
  "uk": {
    "forgotPassword": {
      "title": "🔑 Скидання пароля",
      "submit": "Надіслати посилання для скидання",
      "sent": "Якщо цю адресу зареєстровано, посилання для скидання вже надіслано."
    }
  }
};

export default resources;
